import { baseApi } from "./baseApi";

export const notificationApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({

    // GET /api/coach/notifications
    getNotifications: builder.query({
      query: () => "/coach/notifications",
      providesTags: ["Notifications"],
      pollingInterval: 30000,
      transformResponse: (response) => {
        const data = response?.data || (Array.isArray(response) ? response : []);
        return data.filter(n => !n.lu && !n.read);
      },
    }),

    //  GET /api/coach/notifications/{id} — backend utilise GET pour marquer lu
    markNotificationAsRead: builder.mutation({
      query: (id) => ({
        url: `/coach/notifications/${id}`,
        method: "GET",
      }),
      invalidatesTags: ["Notifications"],
    }),

    markAllNotificationsAsRead: builder.mutation({
      queryFn: async (_arg, _api, _extraOptions, baseQuery) => {
        // Récupère la liste actuelle des notifications non lues
        const listRes = await baseQuery("/coach/notifications");
        if (listRes.error) return { error: listRes.error };

        const raw = listRes.data;
        const data = raw?.data || (Array.isArray(raw) ? raw : []);
        const unread = data.filter(n => !n.lu && !n.read);

        // Marque chacune comme lue (séquentiellement pour rester simple)
        for (const n of unread) {
          await baseQuery(`/coach/notifications/${n.id}`);
        }

        return { data: { success: true, count: unread.length } };
      },
      invalidatesTags: ["Notifications"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsAsReadMutation,
} = notificationApi;